import { CourseData } from '@data/course/courseData';
import firebase from 'firebase/app';
import 'firebase/firestore';

export function getInstructors(courseData: CourseData) {
  return firebase
    .firestore()
    .collection('instructors')
    .where(firebase.firestore.FieldPath.documentId(), 'in', courseData.instructorIds);
}
